import { render, staticRenderFns } from "./Synapse.vue?vue&type=template&id=a45329aa&scoped=true"
import script from "./Synapse.vue?vue&type=script&lang=js"
export * from "./Synapse.vue?vue&type=script&lang=js"
import style0 from "./Synapse.vue?vue&type=style&index=0&id=a45329aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45329aa",
  null
  
)

export default component.exports